import { Action } from '@ngrx/store';

export const ConfigurationActions = {
  UPDATE_TOKEN: '[Configuration] Update Token',
  TOKEN_UPDATED: '[Configuration] Token Updated',
  USERNAME_UPDATED: '[Configuration] Username Updated',
  UPDATE_SITE_INFORMATION: '[Site Information] Update',
};

export interface IConfigurationAction extends Action {
  payload?: object;
}

export class UpdateToken implements IConfigurationAction {
  readonly type = ConfigurationActions.UPDATE_TOKEN;
}

export class TokenUpdated implements IConfigurationAction {
  readonly type = ConfigurationActions.TOKEN_UPDATED;
  constructor(public payload: any) {}
}

export class UsernameUpdated implements IConfigurationAction {
  readonly type = ConfigurationActions.USERNAME_UPDATED;
  constructor(public payload: any) {}
}

export class UpdateSiteInformation implements IConfigurationAction {
  readonly type = ConfigurationActions.UPDATE_SITE_INFORMATION;
  constructor(public payload: any) {}
}
